import z from 'zod'
import { schema as baseSchema } from '../SectionAssignmentConversation/schema'
import { firestoreWriteTimestamp } from '../shared/schema'

export const schema = baseSchema.extend({
  promptVersionId: z.string(),
  sectionId: z.string(),
  assignmentId: z.string(),
})

export const writeSchema = schema.extend({
  createdAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    promptVersionId: '',
    sectionId: '',
    assignmentId: '',
  })
)

export interface FirestoreSectionAssignmentConversationPromptTest extends z.infer<
  typeof schema
> {}
